var _path, _circle, _path2, _path3, _path4, _path5, _circle2, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoPoints = function SvgNoPoints(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M2.394 22.572h25.781"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.59,
    cy: 11.823,
    r: 4.578,
    fill: "#FDF6D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M7.136 16.901h4.9v5.643h-4.9zM16.507 22.511v-5.604h5.227v5.604M19.168 16.921v5.65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0EAC2",
    d: "M26.022 6c-1.816 0-2.648 4.163-2.838 6.244l.868.5v3.507c.3.226.83.567 2.17.567 3.04 0 2.772-3.172 2.772-4.073 0-.902-.701-6.745-2.972-6.745Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M8.116 13.76h5.954M14.11 22.551V8.247l10.029 4.435v9.87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m21.757 13.787-5.329-2.324V15h5.329v-1.213ZM4.84 22.59v-6.872"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.578,
    cy: 11.317,
    r: 4.078,
    stroke: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M23.184 12.244C23.374 10.163 24.206 6 26.022 6c2.27 0 2.972 5.843 2.972 6.745 0 .901.267 4.073-2.771 4.073-1.342 0-1.871-.34-2.17-.567"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M26.186 9.833v12.78M26.266 14.586l1.165-1.594M26.186 12.658l-1.337-1.406"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBE00",
    d: "m2.937 10.105 1.894 1.85 4.106-4.248"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoPoints);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "No_Points.c87cdb3c59e6b3a3023cb2353ac65093.svg";